import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import ViewPortDetails from './ViewPortDetails';

const ViewPortDialog = ({ open, onOpenChange, port }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
       <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Port Location</DialogTitle>
        </DialogHeader>
        <ViewPortDetails 
          port={port}
          onCancel={() => onOpenChange(false)} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default ViewPortDialog;